import React, { useState, useEffect } from 'react';
import { API_BASE } from '../App';

const CreateFaultReport = ({ user, token, onBack }) => {
  const [assignedProducts, setAssignedProducts] = useState([]);
  const [formData, setFormData] = useState({
    product_id: '',
    title: '',
    description: '',
    priority: 'normal'
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchAssignedProducts();
  }, []);

  const fetchAssignedProducts = async () => {
    try {
      const response = await fetch(`${API_BASE}/my-assigned-products`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setAssignedProducts(data);
      }
    } catch (error) {
      console.error('Ürünler yüklenirken hata:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          type: 'ariza',
          title: formData.title,
          description: formData.description,
          priority: formData.priority,
          product_id: formData.product_id
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Arıza bildirimi başarıyla oluşturuldu!');
        setFormData({ product_id: '', title: '', description: '', priority: 'normal' });
        setTimeout(() => onBack(), 2000);
      } else {
        setMessage(data.error || 'Hata oluştu');
      }
    } catch (error) {
      setMessage('Bağlantı hatası');
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <div className="form-container">
        <button onClick={onBack} className="btn-back">Geri Dön</button>
        <h2>Arıza Bildirimi</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Arızalı Ürün:</label>
            <select
              value={formData.product_id}
              onChange={(e) => setFormData({...formData, product_id: e.target.value})}
              required
            >
              <option value="">Ürün seçin...</option>
              {assignedProducts.map(product => (
                <option key={product.id} value={product.id}>
                  {product.product_name} ({product.serial_code})
                </option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label>Arıza Başlığı:</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({...formData, title: e.target.value})}
              required
              placeholder="Arıza kısaca tanımlayın"
            />
          </div>
          
          <div className="form-group">
            <label>Arıza Detayı:</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              required
              rows="6"
              placeholder="Arızayı detaylı olarak açıklayın..."
            />
          </div>
          
          <div className="form-group">
            <label>Öncelik:</label>
            <select
              value={formData.priority}
              onChange={(e) => setFormData({...formData, priority: e.target.value})}
            >
              <option value="low">Düşük</option>
              <option value="normal">Normal</option>
              <option value="high">Yüksek</option>
              <option value="urgent">Acil</option>
            </select>
          </div>
          
          <button type="submit" disabled={loading || !formData.product_id} className="btn-primary">
            {loading ? 'Gönderiliyor...' : 'Arıza Bildir'}
          </button>
        </form>
        
        {message && (
          <div className={`message ${message.includes('başarı') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateFaultReport;